import React from "react";
import {
    METRIC_UTILISATION_CONFIG
} from "../../../../constants/metric-config";

export default function ProgressBarChart(props) {

    var data = props.data;
	var metric = props.metric;
	
	
	var metricConfig =
	    METRIC_UTILISATION_CONFIG[metric];

	var metricColour =
	    metricConfig && metricConfig.color
	        ? metricConfig.color
	        : "#5a9bd6";

    if (!data || !Array.isArray(data) || data.length === 0) {
        return null;
    }

    // --------------------------------------------------------
    // FORMAT DATE
    // --------------------------------------------------------

    function formatUKDate(dateStr) {

        if (!dateStr) {
            return "-";
        }

        var d = new Date(dateStr);

        var day = String(d.getDate()).padStart(2, "0");

        var month = String(d.getMonth() + 1).padStart(2, "0");

        return day + "/" + month;
    }

    // --------------------------------------------------------
    // MAX VALUE
    // --------------------------------------------------------

    var max = Math.max.apply(
        null,
        data.map(function (d) {

            return d.avgUtilisation || 0;

        })
    );

    if (max < 1) {
        max = 1;
    }

    // --------------------------------------------------------
    // STYLES
    // --------------------------------------------------------

	var containerStyle = {
	    background:
	        "linear-gradient(160deg, " +
	        "rgba(19,25,32,0.78) 0%, " +
	        "rgba(9,17,26,0.84) 100%)",

	    backdropFilter: "blur(4px)",
	    WebkitBackdropFilter: "blur(4px)",

	    border: "1px solid rgba(141,200,240,0.18)",
	    borderBottom: "2px solid #20AFE8",

	    borderRadius: "10px",

	    boxShadow:
	        "0 12px 32px rgba(0,0,0,0.24), " +
	        "inset 0 1px 0 rgba(255,255,255,0.06)",

	    padding: "14px 10px",
	    marginBottom: "12px"
	};

    var gridStyle = {
        display: "grid",
        gridTemplateColumns:
            "310px repeat(" + data.length + ", 1fr)",
        alignItems: "end"
    };

    // --------------------------------------------------------
    // RENDER
    // --------------------------------------------------------

    return (

        <div style={containerStyle}>

            <div style={gridStyle}>

                {/* spacer */}
                <div />

                {data.map(function (row, i) {

                    var date =
                        row.date;

                    var value =
                        row.avgUtilisation || 0;

                    var maxBarHeight =
                        90;

                    var barHeight =
                        (value / max) * maxBarHeight;

                    return (

                        <div
                            key={metric + "_" + date + "_" + i}
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "flex-end",
                                height: "120px"
                            }}
                        >

                            {/* VALUE */}
                            <div
                                style={{
                                    fontSize: "11px",
                                    color: "#e2e8f0",
                                    marginBottom: "4px"
                                }}
                            >
                                {value.toFixed(1)}%
                            </div>

                            {/* BAR */}
                            <div
                                style={{
                                    width: "55%",
                                    height: barHeight + "px",
									background:
									    "linear-gradient(180deg, " +
									    metricColour + ", " +
									    metricColour + "CC)",

									boxShadow:
									    "0 2px 8px " +
									    metricColour + "66",
                                    borderRadius: "5px"
                                }}
                            />

                            {/* DATE */}
                            <div
                                style={{
                                    fontSize: "10px",
                                    color: "#94a3b8",
                                    marginTop: "6px"
                                }}
                            >
                                {formatUKDate(date)}
                            </div>

                        </div>

                    );

                })}

            </div>

        </div>
    );
}